import { render, staticRenderFns } from "./ChamadoProgramacao.vue?vue&type=template&id=3b79c8c5&"
import script from "./ChamadoProgramacao.vue?vue&type=script&lang=js&"
export * from "./ChamadoProgramacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports